<template>
	<div class="search-row">
		<div class="filter-col">
			<div class="input-group">
				<input type="text"
							 name="quick-filter"
							 placeholder="Search Term"
							 class="form-control"
							 v-model="searchText"
							 @input="updateText" />
				<div class="input-group-btn">
					<button type="button" class="btn">
						<i class="fas fa-search" aria-hidden="true" />
						<span class="sr-only">
							{{ $t('MAIN_CONTENT.GlossarySearch.searchTermsTitleCase') }}
						</span>
					</button>
				</div>
			</div>
		</div>
		<div class="total-col text-right text-primary">
			<button class="btn-unstyled" @click="showAll" v-if="!showAllFlag">
				{{ $t('MAIN_CONTENT.GlossarySearch.viewAllTotalEntries', { count: total }) }}
			</button>
			<button class="btn-unstyled" @click="hideAll" v-else>
				{{ $t('MAIN_CONTENT.GlossarySearch.hideAllTotalEntries', { count: total }) }}
			</button>
		</div>
	</div>
</template>

<script>
	/**
		* @vue-prop {Number} [total=0] - Total number of entries.
		* @vue-data {String} [searchQuery=''] - String to be searched.
	*/
	export default {
		props: {
			total: {
				type: Number,
				default: 0
			},
			searchQuery: {
				type: [String, Number],
				default: ''
			}
		},
		data() {
			return {
				showAllFlag: false,
				searchText: ''
			};
		},
		methods: {
			updateText() {
				this.$emit('updateSearch', this.searchText);
			},
			/**
				* Shows all entries
			*/
			showAll() {
				this.showAllFlag = true;
				this.$emit('showAll');
			},
			hideAll() {
				this.showAllFlag = false;
				this.$emit('hideAll');
			}
		}
	};
</script>
